import { NgModule } from '@angular/core'
import { FloImagePipe } from './flo-image.pipe'

@NgModule({
  declarations: [FloImagePipe],
  exports: [FloImagePipe]
})
export class ImagePipeModule {}
